import { accentHex, initials } from "@/lib/constants";
import { cn } from "@/lib/utils";

const SIZES = {
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-sm",
  lg: "h-14 w-14 text-lg",
  xl: "h-20 w-20 text-2xl",
};

export function MemberAvatar({ member, size = "md", ring = true, className, ...props }) {
  const color = accentHex(member?.color);
  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-full font-display font-semibold text-ink shrink-0",
        SIZES[size],
        className
      )}
      style={{
        backgroundColor: `${color}33`,
        border: ring ? `3px solid ${color}` : "none",
        color,
      }}
      title={member?.name}
      {...props}
    >
      {member?.avatar_url ? (
        <img src={member.avatar_url} alt={member.name} className="h-full w-full rounded-full object-cover" />
      ) : (
        <span>{initials(member?.name)}</span>
      )}
    </div>
  );
}
